<template>
    <div>
        <h3>{{title}}</h3>
        <hr />
        <div class="row">
            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'number' + _uid">{{ $t('contract.number') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="contract.number"
                       :name="'number' + _uid"
                       :id="'number' + _uid">
            </div>

            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'name' + _uid">{{ $t('contract.name') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="contract.name"
                       :name="'name' + _uid"
                       :id="'name' + _uid">
            </div>

            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'subject' + _uid">{{ $t('contract.subject') }}</label>
                <input type="text" class="form-control" readonly v-model="contract.subject" :id="'subject' + _uid">
            </div>

            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'validFrom' + _uid">{{ $t('contract.validFrom') }}</label>
                <date-picker v-model="contract.validFromUtc">
                </date-picker>
            </div>
            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'validTo' + _uid">{{ $t('contract.validTo') }}</label>
                <date-picker v-model="contract.validToUtc">
                </date-picker>
            </div>
            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'conclusionDate' + _uid">{{ $t('contract.conclusionDate') }}</label>
                <div :id="'conclusionDate' + _uid">
                    <date-picker v-model="contract.conclusionDate">
                    </date-picker>
                </div>
            </div>
            <div class="col-md-4 form-group">
                <label class="font-weight-bold" :for="'amount' + _uid">{{ $t('contract.amount') }}</label>
                <input type="text" class="form-control" readonly
                       v-model="contract.amount"
                       :name="'amount' + _uid"
                       :id="'amount' + _uid">
            </div>
            <div class="col-4 form-group">
                <label class="font-weight-bold" :for="'active' + _uid">{{ $t('externalSupplier.active') }}</label>
                <div :id="'active' + _uid">
                    <span :class="contract.active ? 'badge badge-success' : 'badge badge-danger'">{{contract.active ? $t('yes') : $t('no')}}</span>
                </div>
            </div>
            <div class="form-group col-md-12">
                <label class="font-weight-bold" :for="'description' + _uid">{{ $t('person.description')}}</label>
                <textarea rows="3" class="form-control" readonly v-model="contract.description" :id="'description' + _uid"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from './../../components/datepicker/DatePickerDetails';
    import { ContractDetails } from './../../models/models';

    export default {
        components: {
            'date-picker': DatePicker
        },
        props: {
            contract: ContractDetails,
            title: String
        },
        data() {
            return {
            };
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke !important;
    }

    textarea[readonly] {
        background-color: whitesmoke !important;
    }
</style>

